export default __webpack_public_path__ + "static/media/julian_step_2.c6111b04.svg";